module.exports = "/_next/static/images/letter-monotone-6ee3fafb017d03372157ca625b18ae9c.svg";